import { Box } from "@mui/material";
import { CurrencyToggle } from "Components/Dashboard/BalanceWithPaymentActions/DesktopBalance/Components/CurrencyToggle";
import type { BalanceHeaderProps } from "Components/Dashboard/BalanceWithPaymentActions/types";
import { PaperTitle } from "Components/Shared/PaperTitle";
import { Resources, useResource } from "Translations/Resources";

const BalanceResources = Resources.Balance.BalanceContent;

/** Card header: title with the eye toggle beside it, and the currency switcher on the right when there is a choice. */
export const DesktopBalanceHeader = ({
  visibilityToggle,
  currencies,
  selectedCurrency,
  selectCurrency,
}: BalanceHeaderProps) => {
  const { t } = useResource();
  const hasCurrencyChoice = currencies.length > 1 && selectedCurrency != null;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={4}
      minHeight={36}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <PaperTitle>{t(BalanceResources.Title)}</PaperTitle>
        {visibilityToggle}
      </Box>
      {hasCurrencyChoice && (
        <CurrencyToggle
          currencies={currencies}
          selectedCurrency={selectedCurrency}
          onSelect={selectCurrency}
        />
      )}
    </Box>
  );
};
